import { Auth } from "aws-amplify";
import moment from "moment";

import Service from "@services/Service";
import { NATIVE_DATETIME_FORMAT } from "@utils/datetime";

class Authentication extends Service {
  static login(username, password) {
    return new Promise((resolve, reject) => {
      Auth.signIn({
        username,
        password,
      })
        .then((cognitoUser) => {
          if (cognitoUser.challengeName === "NEW_PASSWORD_REQUIRED") {
            reject({
              status: "ERROR",
              code: "NEW_PASSWORD_REQUIRED",
              message: "New password required",
              data: cognitoUser,
            });
          } else {
            /* custom:last_access attribute not implemented in Cognito.
            Auth.updateUserAttributes(cognitoUser, {
              "custom:last_access": moment().format(NATIVE_DATETIME_FORMAT),
            }); */
            resolve(cognitoUser);
          }
        })
        .catch((err) => {
          reject({
            status: "ERROR",
            code: "AUTHENTICATION_ERROR",
            message: "Authentication error",
          });
        });
    });
  }

  static logout() {
    return Auth.signOut();
  }

  static completeNewPassword(user, password) {
    return new Promise((resolve, reject) => {
      Auth.completeNewPassword(user, password)
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject({
            status: "ERROR",
            code: "PASSWORD_REGISTRATION_ERROR",
            message: "Password registration error",
          });
        });
    });
  }

  static currentAuthenticatedUser() {
    return Auth.currentAuthenticatedUser().catch(() => {
      return null;
    });
  }

  static checkAuthentication() {
    return Authentication.currentAuthenticatedUser().then((user) => {
      return !!user;
    });
  }

  static forgotPassword(username) {
    return Auth.forgotPassword(username);
  }

  static confirmForgotPassword(login, code, password) {
    return Auth.forgotPasswordSubmit(login, code, password).catch(() => {
      return null;
    });
  }

  static changePassword(oldPassword, newPassword) {
    return Auth.currentAuthenticatedUser().then((user) => {
      return Auth.changePassword(user, oldPassword, newPassword);
    });
  }
}

export default Authentication;
